import { Schema, type } from "@colyseus/schema"
import { defaultBackgroundSrc, defaultCardSrc } from "../../consts"

export class CustomsClass extends Schema {
  @type("string") cards: string
  @type("string") background: string

  constructor(cards = defaultCardSrc, background = defaultBackgroundSrc) {
    super()

    this.cards = cards
    this.background = background
  }
}

export type Customs = InstanceType<typeof CustomsClass>
